<div class="top_line">
  <div *ngIf="!project" class="top_text">
    <h2>My Tasks</h2>
  </div>

  <div class="menu">
    <div class="filter_buttons">
        <digires-list-input
          [formGroup]="taskFormGroup"
          formCtrlName="selectedLabel"
          placeholder="Label"
          [items]="labels"
          [itemToLabel]="labelToLabel"
        ></digires-list-input>

        <digires-team-member-input *ngIf="project"
          class="owner-filter"
          [formGroup]="taskFormGroup"
          [allTeamMembers]="teamMembers"
          formCtrlName="selectedOwner"
          placeholder="Owner"
        ></digires-team-member-input>

        <digires-list-input *ngIf="!project"
          [formGroup]="taskFormGroup"
          formCtrlName="selectedProject"
          placeholder="Project"
          [items]="myProjects"
          [itemToLabel]="getProjectName"
        ></digires-list-input>

      <button mat-button (click)="resetFilter()" matTooltip="Reset filters." matTooltipPosition="below">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
    <div class="add_button">
      <button [disabled]="isReadOnly" mat-button (click)="openDialog()" *ngIf="project" class="ghost_button">Add task</button>
    </div>
  </div>
</div>

<div class="task-container">

  <div class="task-column">
    <h4>to do</h4>
    <div class="container" id="to do" [dragula]='"nested-bag"' [(dragulaModel)]="toDoTasks">
      <div *ngFor="let task of toDoTasks" class="task-box"  id="{{task.id}}">
        <digires-task-entry class="task" (click)="openDialog(task)" [task]="task"></digires-task-entry>
      </div>
    </div>
  </div>

  <div class="task-column">
    <h4>in progress</h4>
    <div class="container" id="in progress" [dragula]='"nested-bag"' [(dragulaModel)]="inProgressTasks">
      <div *ngFor="let task of inProgressTasks" class="task-box"  id="{{task.id}}">
        <digires-task-entry class="task" (click)="openDialog(task)" [task]="task"></digires-task-entry>
      </div>
    </div>
  </div>

  <div class="task-column">
    <h4>done</h4>
    <div class="container" id="done" [dragula]='"nested-bag"' [(dragulaModel)]="doneTasks">
      <div *ngFor="let task of doneTasks" class="task-box"  id="{{task.id}}">
        <digires-task-entry class="task" (click)="openDialog(task)" [task]="task"></digires-task-entry>
      </div>
    </div>
  </div>
</div>
